import store from 'Store';
import { get } from 'Utils/common';
import { INVESTMENT_STYLE } from 'Config/constans';
import { getCookie } from 'Utils/session';
import ownershipDurationFilter from 'Helpers/filters/ownership-duration';
import * as CONSTS from './constans';
import * as EVENTS from './events';

export function getBaseParams() {
  const profileModel = store.getters['profile/profileModel'];
  return {
    userEmail: profileModel.email,
    user_email: profileModel.email,
    hubspot_id: getCookie('hubspotutk'),
    djadmin_id: profileModel.user_id,
  };
}

export function getAccreditationParams() {
  const profileModel = store.getters['profile/profileModel'];
  const finSituation = CONSTS.ACCREDITED_MAP[profileModel.financial_situation || 0];
  return {
    accredited: profileModel.isAccredited || finSituation,
    finSituation,
    financial_situation: finSituation,
  };
}

export function getProfileAccreditationParams() {
  const selectedProfile = store.getters['profile/selectedInvestmentProfile'];
  return {
    accreditation_status: selectedProfile.accreditation_status,
    important: selectedProfile.accreditation_permanent_approved,
    accreditation_date: selectedProfile.accreditation_date,
    accreditation_type: selectedProfile.accreditation_type,
  };
}

export function getVerifiedPersonParams() {
  return {
    verified: 'verified',
    verification_status: 'verified',
  };
}

export function getVerificationStatus() {
  return {
    verification_status: store.getters['profile/KYCStatus'],
  };
}

export function getLinkedBankAccountParams() {
  return {
    linked: true,
    bank_account_linked: true,
  };
}

export function getWalletParams() {
  const walletBalance = store.getters['profile/walletBalanceValue'];
  const isLinkedBankAccount = store.getters['profile/isLinkedBankAccount'];
  return {
    walletBalance,
    wallet_balance: walletBalance,
    bank_account_linked: isLinkedBankAccount,
  };
}

export function getFarmParams() {
  const farmData = store.getters['farm/farmData'] || {};
  const { farmSubscribedPercent } = farmData;
  const farmTotalShares = farmData.area_size * 10;
  const maxOwnershipDuration = ownershipDurationFilter(farmData.ownership_duration);
  const grossCashYield = `${farmData.gross_yield}%`;
  const netAnnualReturn = `${farmData.net_irr}%`;
  const investmentStyle = INVESTMENT_STYLE[farmData.invested_style];
  return {
    id: farmData.id,
    farmTotalAcres: farmData.area_size,
    total_acres: farmData.area_size,
    farmTotalShares,
    total_shares: farmTotalShares,
    subscribedPercent: farmSubscribedPercent,
    percent_subscribed: farmSubscribedPercent,
    acrePrice: farmData.price_per_acre,
    price_per_acre: farmData.price_per_acre,
    farm_name: farmData.name,
    farmPrice: farmData.price,
    farm_price: farmData.price,
    farm_description: farmData.description,
    primaryCrop: farmData.crop,
    primary_crop: farmData.crop,
    investmentStyle,
    investment_style: investmentStyle,
    grossCashYield,
    gross_cash_yield: grossCashYield,
    netAnnualReturn,
    net_annual_return: netAnnualReturn,
    minSharesInv: farmData.min_shares_amount,
    minimum_investment: farmData.min_shares_amount,
    maxSharesInv: farmData.remaining_shares,
    maxOwnershipDuration,
    maximum_ownership_duration: maxOwnershipDuration,
    farm_state: farmData.state,
    farm_county: farmData.county,
    image_url: get(farmData, 'thumbnail.thumbnail.url', ''),
  };
}

export function getClientParams() {
  const {
    email: userEmail,
    first_name: firstName,
    last_name: lastName,
    phone = '',
    updated_date: updatedDate,
  } = store.getters['profile/profileData'];
  return {
    userEmail,
    user_email: userEmail,
    firstName,
    first_name: firstName,
    lastName,
    last_name: lastName,
    phone,
    updated_date: updatedDate,
  };
}

export function getSignUpParams(stepNumber, signUpData) {
  const params = {
    sign_up_step_number: stepNumber,
    sign_up_step: CONSTS.SIGNUP_STEP_MAP[stepNumber - 1],
  };
  if (stepNumber >= 3) {
    const finSituation = CONSTS.ACCREDITED_MAP[signUpData.financial_situation || 0];
    Object.assign(params, { finSituation, financial_situation: finSituation });
  }
  if (stepNumber >= 4) {
    let investmentExperience = 'skip';
    if (signUpData.invested_in_farmland_before === true) investmentExperience = 'yes';
    else if (signUpData.invested_in_farmland_before === false) investmentExperience = 'no';
    params.farmland_investment_experience = investmentExperience;
  }
  return params;
}

export function getSignUpSocialParams(stepNumber, signUpData = {}) {
  const profileModel = store.getters['profile/profileModel'];
  const params = {
    sign_up_step_number: stepNumber,
    sign_up_step: CONSTS.SIGNUP_SOCIAL_STEP_MAP[stepNumber - 1],
    social_login_type: profileModel.social,
  };
  if (stepNumber >= 3) {
    Object.assign(params, getAccreditationParams());
  }
  if (stepNumber >= 4) {
    let investmentExperience = 'skip';
    if (signUpData.invested_in_farmland_before === true) investmentExperience = 'yes';
    else if (signUpData.invested_in_farmland_before === false) investmentExperience = 'no';
    params.farmland_investment_experience = investmentExperience;
  }
  return params;
}

export function getProfileParams() {
  return {
    ...getAccreditationParams(),
    ...getProfileAccreditationParams(),
    ...getWalletParams(),
    ...getVerificationStatus(),
    ...getClientParams(),
  };
}

export function getParams(event) {
  const params = getBaseParams();
  switch (event) {
    case EVENTS.ACCREDITATION_AFTER_REGISTER:
      return Object.assign(params, getAccreditationParams());
    case EVENTS.ACCREDITED_ONCE:
      return Object.assign(params, getClientParams());
    case EVENTS.VERIFIED_PERSON:
      return Object.assign(params, getVerifiedPersonParams());
    case EVENTS.LINKED_BANK_ACCOUNT:
      return Object.assign(params, getLinkedBankAccountParams());
    case EVENTS.WALLET_FUNDS_ADDED:
      return Object.assign(params, getWalletParams());
    case EVENTS.VIEW_FARM:
    case EVENTS.START_INVESTMENT:
    case EVENTS.INVESTMENT_AMOUNT:
    case EVENTS.INVESTMENT_PROFILE:
    case EVENTS.INVESTMENT_OWNERSHIP:
    case EVENTS.INVESTMENT_SIGNATURES:
    case EVENTS.INVESTMENT_ESCROW:
    case EVENTS.INVESTMENT_ACCREDITATION:
    case EVENTS.INVESTMENT_CONFIRMATION:
      return Object.assign(params, getFarmParams());
    default:
      return params;
  }
}
